import * as React from 'react';

export interface IInlineActionLinkProps {
  text: String;
  onClick: () => void;
}

export const InlineActionLink: React.FunctionComponent<
  IInlineActionLinkProps
> = props => {
  return (
    <div className='cursor-pointer hover:underline' onClick={props.onClick}>
      {props.text}
    </div>
  );
};
